const Technology = require("../../../entities/Technology");
const {TechnologyNames, TechnologyTypes, Age}  = require("../../Constants");

class Farm extends Technology {
    constructor(age, techName, scienceCost, workerCost, multiplier){
        super(
            age,
            Farm.GetType(),
            techName,
            scienceCost,
            workerCost,
            {
                playerStateAltering:
                    (playerState) => {
                        playerState.foodProductionCalculationDelegate.push({
                            Source: this,
                            Action: () => this.GetWorkerCount() * multiplier,
                        });
                        playerState.foodProductionDelegate.push({
                            Source: this,
                            Priority: multiplier,
                            Action: () => {
                                // Each worker produces one blue token worth `multiplier` food.
                                // Limited by the blue bank; Priority makes higher-level cards produce first.
                                var produced = Math.min(this.GetWorkerCount(), playerState.blueBank);
                                this.AddContent("blueCubes", produced);
                            },
                        });
                        playerState.currentFoodCalculationDelegate.push({
                            Source: this,
                            Action: () => this.GetBlueCubeCount() * multiplier,
                        })
                    }
            }
        )
        this.multiplier = multiplier;
    }
    static GetType = () => TechnologyTypes.Production.Farm;
}

class Agriculture extends Farm {
    constructor(){
        super(Agriculture.GetAge(), Agriculture.GetName(), 0, 2, 1)
    }

    static GetInstance = () => new Agriculture();
    static GetAge = () => Age.AgeA;
    static GetName = () => TechnologyNames.Production.Agriculture;
}

class Irrigation extends Farm {
    constructor(){
        super(Irrigation.GetAge(), Irrigation.GetName(), 3, 4, 2)
    }

    static GetInstance = () => new Irrigation();
    static GetAge = () => Age.Age1;
    static GetName = () => TechnologyNames.Production.Irrigation;
}

class SelectiveBreeding extends Farm {
    constructor(){
        super(SelectiveBreeding.GetAge(), SelectiveBreeding.GetName(), 5, 6, 3)
    }

    static GetInstance = () => new SelectiveBreeding();
    static GetAge = () => Age.Age2;
    static GetName = () => TechnologyNames.Production.SelectiveBreeding;
}

class MechanizedAgriculture extends Farm {
    constructor(){
        super(MechanizedAgriculture.GetAge(), MechanizedAgriculture.GetName(), 7, 8, 5)
    }

    static GetInstance = () => new MechanizedAgriculture();
    static GetAge = () => Age.Age3;
    static GetName = () => TechnologyNames.Production.MechanizedAgriculture;
}

module.exports = {
    Agriculture,
    Irrigation,
    SelectiveBreeding,
    MechanizedAgriculture
}